import React from 'react';

class ManagerForms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount = () => {
    }

    render() {
        return (
            <>
              ManagerForms
            </>
        )
    }
}

export default ManagerForms;

